import React, { Suspense } from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import Cookies from 'js-cookie';
import { CRM_COOKIE_ACCESS } from '@moxie/constants';
import { LoaderComponent } from '@crm/src/shared/loader';

const CrmLogProtectedRoute = ({
  component: Component,
  ...rest
}: RouteProps | any): any => {
  return (
    <Route
      {...rest}
      render={(props) =>
        Cookies.get(CRM_COOKIE_ACCESS) ? (
          <Redirect to="/dashboard" />
        ) : (
          <Suspense
            fallback={
              <>
              <LoaderComponent/>
              </>
            }
          >
            <Component {...props} />
          </Suspense>
        )
      }
    />
  );
};

export { CrmLogProtectedRoute };
